// extracted by mini-css-extract-plugin
var _1 = "hTdrEJRhPwXpHO1zbYG6";
export { _1 as "brDataGrid" }
